import NetworkLogic from "../Shared/NetworkLogic";
import UIManager from "../Shared/UIManager";

class YinShangAccount {
    private _serverData: {} = null
    //private _yinShangDomain = null;
    // set serverData (value) {
    //     this._serverData = value
    // }
    // //
    // get serverData () {
    //     return this._serverData
    // }


    async getYinShangAccount() {
        if (!this._serverData) {
            this._serverData = await this._getYinShangAccount();
        }
        return this._serverData;
    }

    // private _getYinShangDomain():Promise<any>{
    //     return new Promise<any>(resolve => {
    //         NetworkLogic.getYinShangDomain(function (data) {
    //             resolve(data.value0)
    //         }.bind(this),function () {
    //             resolve(null)
    //         }.bind(this))
    //     })
    // }

    private _getYinShangAccount():Promise<any>{
        return new  Promise<any>(resolve => {
            UIManager.showLoadingUI()
            NetworkLogic.addYinShangAccount(function (data) {
                UIManager.hideLoadingUI()
                resolve(data)
            }.bind(this),function (){
                UIManager.hideLoadingUI()
                resolve(null)
            })
        })

    }


}

export default new YinShangAccount()